import React, { useMemo, useRef, useState, useEffect } from "react";
import termsImg from "../../images/terms-icon.svg";
import documentalImg from "../../images/bullet_gestao_documental.png";

export default function TermsStep({
    terms = [],
    documents = [],
    acceptedTerms = {},
    acceptedDocs = {},
    onChange,
    onAllAcceptedChange,
}) {
    const [opened, setOpened] = useState({});
    const lastSentRef = useRef(null);

    const getDocKey = (doc) => doc?.id || doc?.url || doc?.nome;

    const bytesToKB = (b) => {
        const n = Number(b || 0);
        if (!n) return null;
        const kb = Math.round(n / 1024);
        return `${kb} KB`;
    };

    const handleOpenDoc = (doc) => {
        const key = getDocKey(doc);
        setOpened((s) => ({ ...s, [key]: true }));

        const next = { ...(acceptedDocs || {}), [key]: true };
        if (typeof onChange === "function") {
            onChange({ target: { name: "acceptedDocs", value: next } });
        }
    };

    const toggleAcceptTerm = (term) => {
        const id = term?.id || term?.texto;
        const next = { ...(acceptedTerms || {}), [id]: !acceptedTerms[id] };
        if (typeof onChange === "function") {
            onChange({ target: { name: "acceptedTerms", value: next } });
        }
    };

    const allAccepted = useMemo(() => {
        const termsOk =
            !terms?.length || terms.every((t) => !!acceptedTerms[t?.id || t?.texto]);

        const docsOk =
            !documents?.length || documents.every((d) => !!acceptedDocs[getDocKey(d)]);

        return termsOk && docsOk;
    }, [terms, documents, acceptedTerms, acceptedDocs]);

    useEffect(() => {
        if (lastSentRef.current === allAccepted) return;
        lastSentRef.current = allAccepted;
        if (typeof onAllAcceptedChange === "function") {
            onAllAcceptedChange(allAccepted);
        }
    }, [allAccepted, onAllAcceptedChange]);

    return (
        <div className="passo1-container">
            <div className="passo1-header">
                <div className="icone-porquinho">
                    <img src={termsImg} alt="icone-termos" />
                </div>
                <div className="passo1-title-box">
                    <div className="passo1-titulo">Termos e Condições</div>
                    <div className="passo1-subtitulo" style={{ marginTop: 2 }}>
                        Leia e aceite as declarações, e abra os documentos para continuar.
                    </div>
                </div>
            </div>
            <div className="passo1-box">
                {terms?.length > 0 && (
                    <div className="form-group" style={{ marginBottom: 16 }}>
                        {terms.map((t) => {
                            const id = t?.id || t?.texto;
                            const isAccepted = !!acceptedTerms[id];

                            return (
                                <div key={id} className="term-item">
                                    <label className="term-item label">
                                        <input
                                            type="checkbox"
                                            checked={isAccepted}
                                            onChange={() => toggleAcceptTerm(t)}
                                        />

                                        <span
                                            className="passo2-texto"
                                            dangerouslySetInnerHTML={{ __html: t.texto || "" }}
                                        />
                                    </label>
                                </div>
                            );
                        })}
                    </div>
                )}



                <div className="form-group">
                    <div className="docs-intro">
                        Para continuar é necessária a leitura dos seguintes documentos:
                    </div>

                    {(!documents || documents.length === 0) && (
                        <div style={{ color: "#666", fontSize: 13, marginTop: 8 }}>
                            Sem documentos disponíveis.
                        </div>
                    )}

                    <div className="doc-list">
                        {documents?.map((doc) => {
                            const key = getDocKey(doc);
                            const isOpened = !!opened[key];
                            const size = bytesToKB(doc.bytes);
                            const ext = (doc.extension || "pdf").toUpperCase();

                            return (
                                <div key={key} className={`doc-row ${isOpened ? "opened" : ""}`}>
                                    <span className="doc-icon" aria-hidden>
                                        <img
                                            src={documentalImg}
                                            alt=""
                                            width={18}
                                            height={18}
                                            className="doc-icon-img"
                                        />
                                    </span>

                                    <a
                                        href={doc.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="doc-link"
                                        title={doc.nome}
                                        onClick={() => handleOpenDoc(doc)}
                                    >
                                        {doc.nome}
                                    </a>

                                    <div className="doc-meta">
                                        {ext}{size ? ` · ${size}` : ""}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
}
